import React from "react";
import AdminPanel from "../components/AdminPanel";

export default function Admin() {
  return <AdminPanel />;
}
